/**
 * Filter op categorie in het blogoverzicht.
 *
 * Filtert in de browser en laadt geen nieuwe pagina: de termpagina's van de
 * taxonomie bestaan niet (geen taxonomy-template, zie de toelichting in
 * blog/index.antlers.html), en met een handvol artikelen staat alles toch al
 * in de HTML.
 *
 * De keuze komt wel in de URL als ?category=, net als bij het portfoliofilter,
 * zodat een gefilterd overzicht te delen is en de knop "terug" werkt.
 */
export default function blogFilter () {
    const filter = document.querySelector('.blog-filter');
    const items = [...document.querySelectorAll('.blog-cards__item')];
    const empty = document.querySelector('.blog-cards__empty');

    if (!filter || items.length === 0) return;

    const chips = [...filter.querySelectorAll('.blog-filter__chip')];

    const apply = (category) => {
        // Een categorie uit de URL die niet meer bestaat valt terug op alles;
        // anders kijkt de bezoeker tegen een leeg overzicht aan zonder knop die
        // ingedrukt lijkt.
        const known = chips.some(chip => chip.dataset.category === category);
        const active = known ? category : '';

        chips.forEach(chip => {
            chip.setAttribute('aria-pressed', String(chip.dataset.category === active));
        });

        let visible = 0;

        items.forEach(item => {
            const match = active === '' || item.dataset.category === active;
            item.hidden = !match;
            if (match) visible++;
        });

        if (empty) empty.hidden = visible > 0;

        return active;
    };

    filter.addEventListener('click', evt => {
        const chip = evt.target.closest('.blog-filter__chip');

        if (!chip) return;

        const active = apply(chip.dataset.category);
        const url = new URL(window.location);

        if (active) {
            url.searchParams.set('category', active);
        } else {
            url.searchParams.delete('category');
        }

        window.history.pushState({ category: active }, '', url);
    });

    // Terug en vooruit in de geschiedenis horen het overzicht mee terug te zetten;
    // zonder deze regel verandert alleen de URL en blijft het filter staan.
    window.addEventListener('popstate', () => {
        apply(new URL(window.location).searchParams.get('category') ?? '');
    });

    apply(new URL(window.location).searchParams.get('category') ?? '');
}
